import { translate } from "../wiring/AppDomain";

export enum UserRole {
    undefined = 0,
    administrator = 10
}

export const translateRole = (r: UserRole) => translate(`user.role.${r}`);
